const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

/** Very light email check */
export function hasValidEmail(v) {
  if (!v) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
}

/** Accepts +263..., 07..., 263..., etc. Returns E.164-ish or empty string */
export function hasValidPhone(v) {
  return normalizePhoneIntl(v) !== "";
}

function normalizePhoneIntl(v) {
  if (!v) return "";
  let s = String(v).replace(/[^\d+]/g, ""); // keep digits and +

  // if no leading + and looks like ZW 07..., convert to +263...
  if (!s.startsWith("+")) {
    if (s.startsWith("0")) s = `+263${s.slice(1)}`;
    else if (s.startsWith("263")) s = `+${s}`;
    else if (/^\d{7,15}$/.test(s)) s = `+${s}`;
  }

  // final sanity
  if (!/^\+\d{7,15}$/.test(s)) return "";
  return s;
}

/**
 * Build a tracked click URL that redirects via the backend.
 * channel: 'email' | 'gmail' | 'outlook' | 'yahoo' | 'tel' | 'whatsapp' | 'calendar'
 * params: {
 *  to: string,
 *  contact_id?: number|string,
 *  source: string,
 *  contact_name?: string,
 *  subject?, body?, text?, target?
 * }
 */
export function trackedUrl(channel, params = {}) {
  const { source } = params;
  if (!channel || !source) return undefined;

  const ch = String(channel).toLowerCase();

  let to = params.to ?? "";
  let target = params.target || "";

  const emailChannels = new Set(["email", "gmail", "outlook", "yahoo"]);

  // Validation + normalization
  if (emailChannels.has(ch)) {
    if (!hasValidEmail(to)) return undefined;
    to = String(to).trim();
  } else if (ch === "tel" || ch === "whatsapp") {
    const p = normalizePhoneIntl(to);
    if (!p) return undefined;
    to = p;
  } else if (ch === "calendar") {
    if (!target) return undefined;
  } else {
    return undefined;
  }

  // Build Query Params
  const qs = new URLSearchParams({
    channel: ch,
    to,
    source: String(source),
  });

  // Only add ID if it exists
  if (params.contact_id) {
    qs.set("contact_id", String(params.contact_id));
  }

  // Pass name for timelines/logging
  if (params.contact_name) {
    qs.set("name", String(params.contact_name));
  }

  // Optional metadata
  if (params.subject) qs.set("subject", String(params.subject));
  if (params.body) qs.set("body", String(params.body));
  if (params.text) qs.set("text", String(params.text));
  if (target) qs.set("target", String(target));

  // IMPORTANT: tracking route lives in routes/api.php => /api/t
  return `${API_BASE}/api/t?${qs.toString()}`;
}
